import Vue from 'vue'

export default {
  setParkingFines: (state, parkingFines) => {
    state.parkingFines = parkingFines
  },
  setSelectedParkingFine: (state, parkingFine) => {
    state.selectedParkingFine = parkingFine
  },
  setParkingFineImages: (state, images) => {
    state.parkingFineImages = images
  },
  setParkingFineInParkingFinesArray: (state, payload) => {
    const existingParkingFine = state.parkingFines.find(
      parkingFine => parkingFine.id === payload.id
    )
    Object.assign(existingParkingFine, payload)
  },
  setPenaltyAppealCommentsForPlace: (state, payload) => {
    state.parkingFines.forEach(parkingFine => {
      if (parkingFine.place && parkingFine.place.id === payload.placeId) {
        Vue.set(
          parkingFine.place,
          'penaltyAppealComments',
          payload.penaltyAppealComments
        )
      }
    })
  },
  setAvailableReasons: (state, payload) => {
    state.availableReasons = payload
  },
  setSelectedParkingFineSpecificKeyValue: (state, data) => {
    Vue.set(state.selectedParkingFine, data.key, data.value)
  },
  setParkingStatusCheckLogs: (state, parkingStatusCheckLogs) => {
    state.parkingStatusCheckLogs = parkingStatusCheckLogs
  },
  setParkingFineReportingTasks: (state, value) => {
    state.parkingFineReportingTasks = value
  },
  setSelectedParkingFineReportingTask: (state, value) => {
    state.selectedParkingFineReportingTask = value
  },
  setParkingFineReportingTaskInParkingFineReportingTasksArray: (
    state,
    payload
  ) => {
    const existingTask = state.parkingFineReportingTasks.find(
      task => task.ID === payload.ID
    )
    Object.assign(existingTask, payload)
  },
  addParkingFineReportingTask: (state, value) => {
    const exists = state.parkingFineReportingTasks.some(task => {
      return task.ID === value.ID
    })
    if (!exists) {
      state.parkingFineReportingTasks.unshift(value)
    }
  },
  removeParkingFineReportingTaskByID: (state, taskId) => {
    const index = state.parkingFineReportingTasks.findIndex(
      task => task.ID === taskId
    )
    state.parkingFineReportingTasks.splice(index, 1)
  },
  setEnforcementOfficers: (state, value) => {
    state.enforcementOfficers = value
  },
  setSelectedEnforcementOfficer: (state, value) => {
    state.selectedEnforcementOfficer = value
  },
  addEnforcementOfficer: (state, value) => {
    const exists = state.enforcementOfficers.some(task => {
      return task.ID === value.ID
    })
    if (!exists) {
      state.enforcementOfficers.unshift(value)
    }
  },
  setEnforcementOfficerInEnforcementOfficersArray: (state, payload) => {
    const existingOfficer = state.enforcementOfficers.find(
      officer => officer.ID === payload.ID
    )
    Object.assign(existingOfficer, payload)
  },
  removeEnforcementOfficerByID: (state, officerId) => {
    const index = state.enforcementOfficers.findIndex(
      officer => officer.ID === officerId
    )
    state.enforcementOfficers.splice(index, 1)
  },
  setEnforcementPlaceGroups: (state, value) => {
    state.enforcementPlaceGroups = value
  },
  setSelectedEnforcementOfficerSpecificKeyValue: (state, data) => {
    Vue.set(state.selectedEnforcementOfficer, data.key, data.value)
  }
}
